<div class="table-header-wrapper">
  @if (hasHeader) {
    <ion-row class="table-header ion-align-items-center">
      <div ngClass="{'alt-header':hasAltHeader}" class="header-text">
        {{ headerText }}
      </div>
    </ion-row>
  }

  <ion-row class="table-icon-header ion-align-items-end">
    @if (hasSearchBar || hasRadioButton) {
      <ion-col class="ion-no-padding left-icons" size="6">
        @if (hasShowingResultsText) {
          {{
            DISP_CONSTANTS.SHOWING_RESULTS.replace("%s", numResults.toString())
          }}
        }
        @if (hasSearchBar) {
          <app-header-search
            [isDisabled]="searchBarDisabled"
            (emitTextChange)="sendSearchSignal($event)"
            (emitClearChange)="sendSearchClear()"
          ></app-header-search>
        }
        <ng-content></ng-content>
        @if (hasRadioButton) {
          <app-radio-button
            [isDisabled]="radioButtonDisabled"
            [header]="radioHeader"
            [radioModel]="radioModel"
            [firstOptionValue]="firstOptionValue"
            [firstOptionName]="firstOptionName"
            [secondOptionValue]="secondOptionValue"
            [secondOptionName]="secondOptionName"
            (buttonChange)="sendRadioButtonChange($event)"
          ></app-radio-button>
        }
      </ion-col>
    }
    <ion-col
      class="ion-no-padding right-icons"
      [size]="hasSearchBar || hasRadioButton ? 6 : 12"
    >
      @if (hasFilter && !hasNoButtons) {
        <app-filter-icon
          [isDisabled]="filterDisabled"
          (clearFilterEvent)="sendFilterSignal()"
        >
        </app-filter-icon>
      }
      @if (hasExcel && !hasNoButtons) {
        <app-excel-icon
          [isDisabled]="excelDisabled"
          (exportExcelEvent)="sendExportExcelSignal()"
        ></app-excel-icon>
      }
      @if (hasDeleteIcon) {
        <!-- Delete icon -->
        <div
          class="delete-wrapper"
          (click)="!deleteDisabled ? sendDeleteSignal() : null"
        >
          <img
            class="delete-icon"
            alt="delete"
            [src]="deleteDisabled ? IMAGES.DELETE_INACTIVE : IMAGES.DELETE_BLUE"
          />
          <div
            [ngClass]="{
              'text-enabled': !deleteDisabled,
              'text-disabled': deleteDisabled,
            }"
          >
            {{ DISP_CONSTANTS.DELETE }}
          </div>
        </div>
      }

      @if (hasEditIcon) {
        <!-- Edit icon -->
        <div
          class="edit-wrapper"
          (click)="!editIconDisabled ? sendEditSignal() : null"
        >
          <img
            class="edit-icon"
            alt="edit"
            [src]="editIconDisabled ? IMAGES.EDIT : IMAGES.EDIT_BLUE"
          />
          <div
            [ngClass]="{
              'text-enabled': !editIconDisabled,
              'text-disabled': editIconDisabled,
            }"
          >
            {{ DISP_CONSTANTS.EDIT }}
          </div>
        </div>
      }

      @if (hasFileDownload) {
        <div class="file-download-wrapper" (click)="sendFileDownloadSignal()">
          <img class="download-icon" alt="download" [src]="IMAGES.FILE_SAVE" />
          <div class="text">
            {{ fileDownloadText }}
          </div>
        </div>
      }

      @if (hasFileUpload) {
        <app-action-button
          alt="file-upload"
          class="action-button file-upload-button"
          [src]="IMAGES.FILE_UPLOAD"
          [buttonText]="fileUploadText"
          buttonFill="outline"
          (addItem)="sendFileUploadSignal()"
        ></app-action-button>
      }

      @if (hasAddItem && !hasNoButtons) {
        @if (hasAlternateAddItem && !hasAddItem && !hasNoButtons) {
          <app-action-button
            alt="add-stop"
            class="action-button"
            [src]="alternateAddItemSrc"
            [buttonText]="alternateAddButtonText"
            (addItem)="sendAddItemSignal(false)"
          ></app-action-button>
        } @else if (hasSingleAlternateAddItem && !hasAlternateAddItem) {
          <!-- TODO: MAKE THIS CLEANER! -->
          <app-action-button
            alt="add-stop"
            class="action-button"
            [src]="alternateAddItemSrc"
            [buttonText]="alternateAddButtonText"
            (addItem)="sendAddItemSignal(false)"
          ></app-action-button>
        } @else {
          <app-new-item-icon
            [isDisabled]="addItemDisabled"
            (addItem)="sendAddItemSignal(true)"
          ></app-new-item-icon>
        }
      }
    </ion-col>
  </ion-row>
</div>
